import { samanthaMediaArray } from './samanthaMedia'
import { samanthaBio } from './samanthaBios'

import { carrieReviewerReviewHinge, mirandaReviewerReviewBumble, charlotteReviewerReviewTinder } from './samanthaReviewerReviews'
import { carrieReviewerProfile, mirandaReviewerProfile, charlotteReviewerProfile } from './samanthaReviewers'

export const carrieProfileReviewHinge = {
  _id: 'carrieProfileReviewHingeId',
  userId: 'samanthaUserId',
  userEmail: 'samantha@email.com',
  datingProfileId: 'samanthaDatingProfileHingeId',
  reviewerProfileId: 'carrieReviewerProfileId',
  reviewerEmail: 'carrie@email.com',
  isAIReview: false,
  isFriendReview: false,
  nameOfLLM: 'NA',
  modelOfLLM: 'NA',
  priceOfReview: 80,
  reviewSubmitted: true,
  type: 'hinge',
  // vibes: ['classy', 'fun', 'relaxed'],
  media: [
    {
      mediaItemId: samanthaMediaArray[4]._id,
      mediaItemURL: samanthaMediaArray[4].url,
      mediaItemDuration: -1,
      mediaItemThumbnail: 'NA',
      mediaType: samanthaMediaArray[4].type,
      caption: samanthaMediaArray[4].captions[0],
      subcaption: samanthaMediaArray[4].subcaptions[0],
    },
    {
      mediaItemId: samanthaMediaArray[1]._id,
      mediaItemURL: samanthaMediaArray[1].url,
      mediaItemDuration: -1,
      mediaItemThumbnail: 'NA',
      mediaType: samanthaMediaArray[1].type,
      caption: samanthaMediaArray[1].captions[0],
      subcaption: samanthaMediaArray[1].subcaptions[0],
    },
    {
      mediaItemId: samanthaMediaArray[3]._id,
      mediaItemURL: samanthaMediaArray[3].url,
      mediaItemDuration: -1,
      mediaItemThumbnail: 'NA',
      mediaType: samanthaMediaArray[3].type,
      caption: samanthaMediaArray[3].captions[0],
      subcaption: samanthaMediaArray[3].subcaptions[0],
    },
    {
      mediaItemId: samanthaMediaArray[7]._id,
      mediaItemURL: samanthaMediaArray[7].url,
      mediaItemDuration: -1,
      mediaItemThumbnail: 'NA',
      mediaType: samanthaMediaArray[7].type,
      caption: samanthaMediaArray[7].captions[0],
      subcaption: samanthaMediaArray[7].subcaptions[0],
    },
    {
      mediaItemId: samanthaMediaArray[0]._id,
      mediaItemURL: samanthaMediaArray[0].url,
      mediaItemDuration: -1,
      mediaItemThumbnail: 'NA',
      mediaType: samanthaMediaArray[0].type,
      caption: samanthaMediaArray[0].captions[0],
      subcaption: samanthaMediaArray[0].subcaptions[0],
    },
    {
      mediaItemId: samanthaMediaArray[2]._id,
      mediaItemURL: samanthaMediaArray[2].url,
      mediaItemDuration: -1,
      mediaItemThumbnail: 'NA',
      mediaType: samanthaMediaArray[2].type,
      caption: samanthaMediaArray[2].captions[0],
      subcaption: samanthaMediaArray[2].subcaptions[0],
    }
  ],
  mediaFeedback: [
    {
      feedback: `You look great here! Love the dress, the necklace, and the lighting! Great start!`,
      verdict: 'Very',
    },
    {
      feedback: `Another fabulous photo of you! You look like Marilyn Monroe!`,
      verdict: 'Very',
    },
    {
      feedback: `Good change of pace with a more sensual vibe`,
      verdict: 'Yes',
    },
    {
      feedback: `Hot by the transitive property for sure! Gotta show off the friends`,
      verdict: 'Yes',
    },
    {
      feedback: `Love the cunning expression and the shirt`,
      verdict: 'Yes',
    },
    {
      feedback: `This one is a bit bland. Maybe add some variety with a travel pic of some sort`,
      verdict: 'Somewhat',
    }
  ],
  bio: {
    bioItemsId: samanthaBio._id,
    vitalInfo: { ...samanthaBio.vitalInfo },
    prompts: [
      { ...samanthaBio.prompts[0] },
      { ...samanthaBio.prompts[1] },
      { ...samanthaBio.prompts[2] }
    ],
    aboutMe: '',
    hobbies: [],
  },
  bioFeedback: {
    vitalInfoFeedback: {
      feedback: `Super put together and well oriented! She has her own PR firm!`,
      verdict: 'Very', 
    },
    aboutMeFeedback: {
      feedback: '',
      verdict: '', 
    },
    promptsFeedback: [
      {
        feedback: `A bit direct... but sense you're looking for short term fun it sets the tone you seem to want`,
        verdict: 'Yes', 
      },
      {
        feedback: `Definitely humorous and fits the tone you're seeking`,
        verdict: 'Yes', 
      },
      {
        feedback: `Another funny one with the right tone. My biggest concern is that you'll come off as a fake profile of someone selling services`,
        verdict: 'Somewhat', 
      }
    ],
  },
  generalFeedback: {
    vibe: `Samantha is very pretty, chic, and well oriented. She's super sexy too, and she's looking for physical intimacy and not much more`,
    good: `Everyone looking for a no strings attached evening (ie. every guy) will swipe right on you sense you're hot and direct about what you're looking for`,
    notGood: `My big concern is that your profile might come across as fake because it's not common for someone as elite as you are to so directly and publicly just be looking for sex`,
    verdict: `Overall the profile definitely displays an attractive Samantha. Maybe change out the final photo and lighten the tone with prompts so that it's clear your profile is real`,
    unusedGoodImages: [],
    unusedGoodBioItems: [],
  },
  reviewerReview: { ...carrieReviewerReviewHinge },
  reviewerProfile: { ...carrieReviewerProfile },
  bioItems: { ...samanthaBio },
  mediaItems: [ ...samanthaMediaArray ],
}

export const mirandaProfileReviewBumble = {
  _id: 'mirandaProfileReviewBumbleId',
  userId: 'samanthaUserId',
  userEmail: 'samantha@email.com',
  datingProfileId: 'samanthaDatingProfileBumbleId',
  reviewerProfileId: 'mirandaReviewerProfileId',
  reviewerEmail: 'miranda@email.com',
  isAIReview: true,
  isFriendReview: false,
  nameOfLLM: 'ChatGPT + Gemini',
  modelOfLLM: 'GPT-4o mini + gemini-1.5-flash-8b',
  priceOfReview: 10,
  reviewSubmitted: true,
  type: 'bumble',
  // vibes: ['classy', 'fun', 'relaxed'],
  media: [
    {
      mediaItemId: samanthaMediaArray[4]._id,
      mediaItemURL: samanthaMediaArray[4].url,
      mediaItemDuration: -1,
      mediaItemThumbnail: 'NA',
      mediaType: samanthaMediaArray[4].type,
      caption: samanthaMediaArray[4].captions[0],
      subcaption: samanthaMediaArray[4].subcaptions[0],
    },
    {
      mediaItemId: samanthaMediaArray[1]._id,
      mediaItemURL: samanthaMediaArray[1].url,
      mediaItemDuration: -1,
      mediaItemThumbnail: 'NA',
      mediaType: samanthaMediaArray[1].type,
      caption: samanthaMediaArray[1].captions[0],
      subcaption: samanthaMediaArray[1].subcaptions[0],
    },
    {
      mediaItemId: samanthaMediaArray[3]._id,
      mediaItemURL: samanthaMediaArray[3].url,
      mediaItemDuration: -1,
      mediaItemThumbnail: 'NA',
      mediaType: samanthaMediaArray[3].type,
      caption: samanthaMediaArray[3].captions[0],
      subcaption: samanthaMediaArray[3].subcaptions[0],
    },
    {
      mediaItemId: samanthaMediaArray[7]._id,
      mediaItemURL: samanthaMediaArray[7].url,
      mediaItemDuration: -1,
      mediaItemThumbnail: 'NA',
      mediaType: samanthaMediaArray[7].type,
      caption: samanthaMediaArray[7].captions[0],
      subcaption: samanthaMediaArray[7].subcaptions[0],
    },
    {
      mediaItemId: samanthaMediaArray[0]._id,
      mediaItemURL: samanthaMediaArray[0].url,
      mediaItemDuration: -1,
      mediaItemThumbnail: 'NA',
      mediaType: samanthaMediaArray[0].type,
      caption: samanthaMediaArray[0].captions[0],
      subcaption: samanthaMediaArray[0].subcaptions[0],
    },
    {
      mediaItemId: samanthaMediaArray[2]._id,
      mediaItemURL: samanthaMediaArray[2].url,
      mediaItemDuration: -1,
      mediaItemThumbnail: 'NA',
      mediaType: samanthaMediaArray[2].type,
      caption: samanthaMediaArray[2].captions[0],
      subcaption: samanthaMediaArray[2].subcaptions[0],
    }
  ],
  mediaFeedback: [
    {
      feedback: `You look great here! Love the dress, the necklace, and the lighting! Great start!`,
      verdict: 'Very',
    },
    {
      feedback: `Another fabulous photo of you! You look like Marilyn Monroe!`,
      verdict: 'Very',
    },
    {
      feedback: `Good change of pace with a more sensual vibe`,
      verdict: 'Yes',
    },
    {
      feedback: `Hot by the transitive property for sure! Gotta show off the friends`,
      verdict: 'Yes',
    },
    {
      feedback: `Love the cunning expression and the shirt`,
      verdict: 'Yes',
    },
    {
      feedback: `This one is a bit bland. Maybe add some variety with a travel pic of some sort`,
      verdict: 'Somewhat',
    }
  ],
  bio: {
    bioItemsId: samanthaBio._id,
    vitalInfo: { ...samanthaBio.vitalInfo },
    prompts: [
      { ...samanthaBio.prompts[0] },
      { ...samanthaBio.prompts[1] },
      { ...samanthaBio.prompts[2] }
    ],
    aboutMe: samanthaBio.aboutMe[0],
    hobbies: [samanthaBio.hobbies[0], samanthaBio.hobbies[1], samanthaBio.hobbies[2], samanthaBio.hobbies[3], samanthaBio.hobbies[4]],
  },
  bioFeedback: {
    vitalInfoFeedback: {
      feedback: `Super put together and well oriented! She has her own PR firm!`,
      verdict: 'Very', 
    },
    aboutMeFeedback: {
      feedback: 'Again, funny but so direct it might make the profile seem fake',
      verdict: 'Somewhat', 
    },
    promptsFeedback: [
      {
        feedback: `A bit direct... but sense you're looking for short term fun it sets the tone you seem to want`,
        verdict: 'Yes', 
      },
      {
        feedback: `Definitely humorous and fits the tone you're seeking`,
        verdict: 'Yes', 
      },
      {
        feedback: `Another funny one with the right tone. My biggest concern is that you'll come off as a fake profile of someone selling services`,
        verdict: 'Somewhat', 
      }
    ],
  },
  generalFeedback: {
    vibe: `Samantha is very pretty, chic, and well oriented. She's super sexy too, and she's looking for physical intimacy and not much more`,
    good: `Everyone looking for a no strings attached evening (ie. every guy) will swipe right on you sense you're hot and direct about what you're looking for`,
    notGood: `My big concern is that your profile might come across as fake because it's not common for someone as elite as you are to so directly and publicly just be looking for sex`,
    verdict: `Overall the profile definitely displays an attractive Samantha. Maybe change out the final photo and lighten the tone with prompts so that it's clear your profile is real`,
    unusedGoodImages: [],
    unusedGoodBioItems: [],
  },
  reviewerReview: { ...mirandaReviewerReviewBumble },
  reviewerProfile: { ...mirandaReviewerProfile },
  bioItems: { ...samanthaBio },
  mediaItems: [ ...samanthaMediaArray ],
}

export const charlotteProfileReviewTinder = {
  _id: 'charlotteProfileReviewTinderId',
  userId: 'samanthaUserId',
  userEmail: 'samantha@email.com',
  datingProfileId: 'samanthaDatingProfileTinderId',
  reviewerProfileId: 'charlotteReviewerProfileId',
  reviewerEmail: 'charlotte@email.com',
  isAIReview: false,
  isFriendReview: false,
  nameOfLLM: 'NA',
  modelOfLLM: 'NA',
  priceOfReview: 80,
  reviewSubmitted: true,
  type: 'tinder',
  // vibes: ['classy', 'fun', 'relaxed'],
  media: [
    {
      mediaItemId: samanthaMediaArray[4]._id,
      mediaItemURL: samanthaMediaArray[4].url,
      mediaItemDuration: -1,
      mediaItemThumbnail: 'NA',
      mediaType: samanthaMediaArray[4].type,
      caption: samanthaMediaArray[4].captions[0],
      subcaption: samanthaMediaArray[4].subcaptions[0],
    },
    {
      mediaItemId: samanthaMediaArray[1]._id,
      mediaItemURL: samanthaMediaArray[1].url,
      mediaItemDuration: -1,
      mediaItemThumbnail: 'NA',
      mediaType: samanthaMediaArray[1].type,
      caption: samanthaMediaArray[1].captions[0],
      subcaption: samanthaMediaArray[1].subcaptions[0],
    },
    {
      mediaItemId: samanthaMediaArray[3]._id,
      mediaItemURL: samanthaMediaArray[3].url,
      mediaItemDuration: -1,
      mediaItemThumbnail: 'NA',
      mediaType: samanthaMediaArray[3].type,
      caption: samanthaMediaArray[3].captions[0],
      subcaption: samanthaMediaArray[3].subcaptions[0],
    },
    {
      mediaItemId: samanthaMediaArray[7]._id,
      mediaItemURL: samanthaMediaArray[7].url,
      mediaItemDuration: -1,
      mediaItemThumbnail: 'NA',
      mediaType: samanthaMediaArray[7].type,
      caption: samanthaMediaArray[7].captions[0],
      subcaption: samanthaMediaArray[7].subcaptions[0],
    },
    {
      mediaItemId: samanthaMediaArray[0]._id,
      mediaItemURL: samanthaMediaArray[0].url,
      mediaItemDuration: -1,
      mediaItemThumbnail: 'NA',
      mediaType: samanthaMediaArray[0].type,
      caption: samanthaMediaArray[0].captions[0],
      subcaption: samanthaMediaArray[0].subcaptions[0],
    },
    {
      mediaItemId: samanthaMediaArray[2]._id,
      mediaItemURL: samanthaMediaArray[2].url,
      mediaItemDuration: -1,
      mediaItemThumbnail: 'NA',
      mediaType: samanthaMediaArray[2].type,
      caption: samanthaMediaArray[2].captions[0],
      subcaption: samanthaMediaArray[2].subcaptions[0],
    }
  ],
  mediaFeedback: [
    {
      feedback: `You look great here! Love the dress, the necklace, and the lighting! Great start!`,
      verdict: 'Very',
    },
    {
      feedback: `Another fabulous photo of you! You look like Marilyn Monroe!`,
      verdict: 'Very',
    },
    {
      feedback: `Good change of pace with a more sensual vibe`,
      verdict: 'Yes',
    },
    {
      feedback: `Hot by the transitive property for sure! Gotta show off the friends`,
      verdict: 'Yes',
    },
    {
      feedback: `Love the cunning expression and the shirt`,
      verdict: 'Yes',
    },
    {
      feedback: `This one is a bit bland. Maybe add some variety with a travel pic of some sort`,
      verdict: 'Somewhat',
    }
  ],
  bio: {
    bioItemsId: samanthaBio._id,
    vitalInfo: { ...samanthaBio.vitalInfo },
    prompts: [
      { ...samanthaBio.prompts[0] },
      { ...samanthaBio.prompts[1] },
      { ...samanthaBio.prompts[2] }
    ],
    aboutMe: samanthaBio.aboutMe[0],
    hobbies: [samanthaBio.hobbies[0], samanthaBio.hobbies[1], samanthaBio.hobbies[2], samanthaBio.hobbies[3], samanthaBio.hobbies[4]],
  },
  bioFeedback: {
    vitalInfoFeedback: {
      feedback: `Super put together and well oriented! She has her own PR firm!`,
      verdict: 'Very', 
    },
    aboutMeFeedback: {
      feedback: 'Again, funny but so direct it might make the profile seem fake',
      verdict: 'Somewhat', 
    },
    promptsFeedback: [
      {
        feedback: `A bit direct... but sense you're looking for short term fun it sets the tone you seem to want`,
        verdict: 'Yes', 
      },
      {
        feedback: `Definitely humorous and fits the tone you're seeking`,
        verdict: 'Yes', 
      },
      {
        feedback: `Another funny one with the right tone. My biggest concern is that you'll come off as a fake profile of someone selling services`,
        verdict: 'Somewhat', 
      }
    ],
  },
  generalFeedback: {
    vibe: `Samantha is very pretty, chic, and well oriented. She's super sexy too, and she's looking for physical intimacy and not much more`,
    good: `Everyone looking for a no strings attached evening (ie. every guy) will swipe right on you sense you're hot and direct about what you're looking for`,
    notGood: `My big concern is that your profile might come across as fake because it's not common for someone as elite as you are to so directly and publicly just be looking for sex`,
    verdict: `Overall the profile definitely displays an attractive Samantha. Maybe change out the final photo and lighten the tone with prompts so that it's clear your profile is real`,
    unusedGoodImages: [],
    unusedGoodBioItems: [],
  },
  reviewerReview: { ...charlotteReviewerReviewTinder },
  reviewerProfile: { ...charlotteReviewerProfile },
  bioItems: { ...samanthaBio },
  mediaItems: [ ...samanthaMediaArray ],
}